document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById(
    window.pahlowmediaSectionId
  );

  if (!section) return;

  const variantContainers = section.querySelectorAll(
    '.variant__container'
  );

  let deliveryUpdateInterval = null;

  // Use relative wording for the next two calendar days,
  // and an unambiguous, readable date for later deliveries.
  function formatDeliveryText(deliveryDate, currentDate) {
    // Compare calendar dates rather than hours so DST changes
    // cannot turn tomorrow into a different day count.
    const deliveryDayUTC = Date.UTC(
      deliveryDate.getFullYear(),
      deliveryDate.getMonth(),
      deliveryDate.getDate()
    );
    const currentDayUTC = Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const daysAway = Math.round(
      (deliveryDayUTC - currentDayUTC) / 86400000
    );

    if (daysAway === 1) return 'Morgen geliefert';
    if (daysAway === 2) return 'Übermorgen geliefert';

    const weekday = new Intl.DateTimeFormat('de-CH', {
      weekday: 'long'
    }).format(deliveryDate);
    const day = String(deliveryDate.getDate()).padStart(2, '0');
    const month = new Intl.DateTimeFormat('de-CH', {
      month: 'long'
    }).format(deliveryDate);

    return `Geliefert am ${weekday}, ${day}. ${month}`;
  }

  function getNextWeekday(date, targetWeekday) {
    const result = new Date(date);
    const currentWeekday = result.getDay();

    let daysUntilTarget =
      (targetWeekday - currentWeekday + 7) % 7;

    if (daysUntilTarget === 0) {
      daysUntilTarget = 7;
    }

    result.setDate(result.getDate() + daysUntilTarget);

    return result;
  }

  function createCountdownText(currentTime, cutoff) {
    const diffMs = cutoff - currentTime;

    const hours = Math.floor(
      diffMs / (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (diffMs / (1000 * 60)) % 60
    );

    return (
      `<span class="delivery-time-left" ` +
      `style="color: #999999 !important; ` +
      `font-size: 0.8em; ` +
      `white-space: nowrap;">` +
      `Bestelle innerhalb ${hours} Std. ` +
      `${minutes} Min.` +
      `</span>`
    );
  }

  // Sitewide promotions cause one extra WORKING day.
  // This remains active for 48 hours after the sale.
  function hasPromotionDelay() {
    const promotions = Array.isArray(window.ysDeliveryPromotions)
      ? window.ysDeliveryPromotions
      : [];

    const now = Date.now();
    const followUpPeriod = 2 * 24 * 60 * 60 * 1000;

    return promotions.some(promotion => {
      const start = Date.parse(promotion.start);
      const end = Date.parse(promotion.end);

      return Number.isFinite(start) &&
        Number.isFinite(end) &&
        now >= start &&
        now <= end + followUpPeriod;
    });
  }

  function updateDeliveryMessage() {
    const deliverySpan = document.getElementById(
      'delivery-message'
    );

    if (!deliverySpan) return;

    const stockContainer = document.querySelector(
      '[data-variant-inventory]'
    );

    if (
      stockContainer &&
      stockContainer.dataset.isGiftCard === 'true'
    ) {
      return;
    }

    const beforeCutoffText =
      window.pahlowmediaDeliverySettings
        ?.beforeCutoffText ||
      'Morgen geliefert';

    const afterCutoffText =
      window.pahlowmediaDeliverySettings
        ?.afterCutoffText ||
      'Übermorgen geliefert';

    const cutoffTime =
      window.pahlowmediaDeliverySettings
        ?.cutoffTime ||
      '15:30';

    const [cutoffHour, cutoffMinute] = cutoffTime
      .split(':')
      .map(number => parseInt(number, 10));

    const now = new Date();

    const zurichTime = new Date(
      now.toLocaleString('en-US', {
        timeZone: 'Europe/Zurich'
      })
    );

    const cutoff = new Date(zurichTime);

    cutoff.setHours(
      cutoffHour,
      cutoffMinute,
      0,
      0
    );

    const weekday = zurichTime.getDay();

    const isFriday = weekday === 5;
    const isSaturday = weekday === 6;
    const isSunday = weekday === 0;
    const isBeforeCutoff = zurichTime < cutoff;

    let deliveryText = '';
    let timeLeftText = '';

    if (hasPromotionDelay()) {
      // Promotion: add one working day to delivery.
      // CH normally uses 1 or 2 working days.
      // DE/AT normally uses 2 or 3 working days.
      // Weekends follow the after-cutoff schedule.

      const isDEorAT =
        window.ysCountryCode === 'DE' ||
        window.ysCountryCode === 'AT';

      const deliveryDate = new Date(zurichTime);

      let workingDaysToAdd =
        isBeforeCutoff && !isSaturday && !isSunday ? 2 : 3;

      if (isDEorAT) {
        workingDaysToAdd += 1;
      }

      while (workingDaysToAdd > 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);

        if (
          deliveryDate.getDay() !== 0 &&
          deliveryDate.getDay() !== 6
        ) {
          workingDaysToAdd--;
        }
      }

      deliveryText = formatDeliveryText(deliveryDate, zurichTime);

      if (isBeforeCutoff && !isSaturday && !isSunday) {
        timeLeftText = createCountdownText(zurichTime, cutoff);
      }

    } else if (
      window.ysCountryCode === 'DE' ||
      window.ysCountryCode === 'AT'
    ) {
      // Germany and Austria: one additional working day.
      const deliveryDate = new Date(zurichTime);

      let workingDaysToAdd =
        isBeforeCutoff && !isSaturday && !isSunday ? 2 : 3;

      while (workingDaysToAdd > 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);

        // Skip Saturday and Sunday.
        if (
          deliveryDate.getDay() !== 0 &&
          deliveryDate.getDay() !== 6
        ) {
          workingDaysToAdd--;
        }
      }

      deliveryText = formatDeliveryText(deliveryDate, zurichTime);

      if (isBeforeCutoff && !isSaturday && !isSunday) {
        timeLeftText = createCountdownText(zurichTime, cutoff);
      }

    } else if (isFriday && isBeforeCutoff) {
      // Friday before cutoff: Monday.
      const monday = getNextWeekday(zurichTime, 1);

      deliveryText = formatDeliveryText(monday, zurichTime);

      timeLeftText = createCountdownText(zurichTime, cutoff);

    } else if (
      (isFriday && !isBeforeCutoff) ||
      isSaturday ||
      isSunday
    ) {
      // Friday after cutoff through Sunday: Tuesday.
      const tuesday = getNextWeekday(zurichTime, 2);

      deliveryText = formatDeliveryText(tuesday, zurichTime);

    } else if (isBeforeCutoff) {
      deliveryText = beforeCutoffText;

      timeLeftText = createCountdownText(zurichTime, cutoff);

    } else {
      // Thursday after cutoff would otherwise imply Saturday.
      // Deliver on Monday instead; no weekend deliveries.
      if (weekday === 4) {
        const monday = getNextWeekday(zurichTime, 1);
        deliveryText = formatDeliveryText(monday, zurichTime);
      } else {
        deliveryText = afterCutoffText;
      }
    }

    deliverySpan.innerHTML =
      `${deliveryText} ${timeLeftText}`.trim();
  }

  function startDeliveryInterval() {
    if (deliveryUpdateInterval) {
      clearInterval(deliveryUpdateInterval);
    }

    updateDeliveryMessage();

    deliveryUpdateInterval = setInterval(
      updateDeliveryMessage,
      60000
    );
  }

  variantContainers.forEach(container => {
    container.addEventListener('click', function() {
      startDeliveryInterval();
    });
  });

  window.updateDeliveryTime = updateDeliveryMessage;

  startDeliveryInterval();
});
